export default __webpack_public_path__ + "static/media/unmask-icon.cf98c706.svg";